import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UIHelper from 'helpers/UIHelper';
import useSingleAcademyCategory from '../useSingleAcademyCategory';
import { getAcademyCategoryViewSections } from '../academyCategoryViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleAcademyCategory = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { singleItem, loading } = useSingleAcademyCategory();

  const sections = useMemo(
    () => getAcademyCategoryViewSections(t, singleItem),
    [t, singleItem],
  );

  const listPath = UIHelper.getListRoute(pathname, 1);
  const pageTitle = singleItem?.title || t('MODULO RETAIL ACADEMY');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`${pathname}/edit`}>{t('MODIFICA')}</Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={listPath}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleAcademyCategory;
